import { buildImgSrc } from '@/helpers/image-url'
import { useIntl } from '@/intl'
import { useAccommodationContext } from '@/react-pages/Prices/AccommodationContext'
import { LazyImage } from '@/scopes/common/components/Image'
import { PriceBreakdownNew } from '@/scopes/prices/components/PriceBasket/PriceBreakdownNew'
import { TripSummaryNew } from '@/scopes/prices/components/PriceBasket/TripSummaryNew'
import { getTransportSelector, transportResponseSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { tk } from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import { styled } from 'styled-components'

const Column = styled.div`
  flex: 1;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 2px solid ${tk('color_semantic_border_subdued')};
  padding: ${tk('spacing_md')};

  @media ${tk('mq_desktop_sm')} {
    flex-direction: row;
  }

  ${Column}:first-child {
    @media ${tk('mq_desktop_sm')} {
      margin-right: ${tk('spacing_md')};
    }

    & > :first-child {
      display: none;
      height: 320px;
      background: ${tk('color_semantic_bg_subdued')};

      @media ${tk('mq_tablet')} {
        display: block;
      }
    }
  }
`

export function PriceBasketNew() {
  const intl = useIntl()
  const { image, name } = useAccommodationContext()
  const { tripSummary } = usePricesSelector(transportResponseSelector)
  const { loading } = usePricesSelector(getTransportSelector)

  if (loading || isEmpty(tripSummary))
    return null

  return (
    <Wrapper>
      <Column>
        <LazyImage
          src={buildImgSrc(image, 640) ?? ''}
          alt={name}
          fallbackText={intl.formatMessage({
            id: 'failed_to_load_image',
          })}
        />
        <TripSummaryNew />
      </Column>
      <Column>
        <PriceBreakdownNew />
      </Column>
    </Wrapper>
  )
}
